import type { OrderPlaybackConfig } from '@order/features-ordering';

// ─── Constants ───────────────────────────────────────────────────────────────

const PLAYBACK_HEADER_FADE_DURATION = 1000;
const PLAYBACK_BODY_FADE_DURATION = 1000;
const PLAYBACK_TIMER_DURATION = 4000;

export const ORDER_PLAYBACK_CONFIG: OrderPlaybackConfig = {
  playbackHeaderFadeDuration: PLAYBACK_HEADER_FADE_DURATION,
  playbackBodyFadeDuration: PLAYBACK_BODY_FADE_DURATION,
  playbackTimerDuration: PLAYBACK_TIMER_DURATION,
  orderSubmissionDelay:
    PLAYBACK_HEADER_FADE_DURATION + PLAYBACK_BODY_FADE_DURATION + PLAYBACK_TIMER_DURATION,
};
